




























import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model } from "../login-controlador";
import { Email } from '@/__env/ext';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{
    get Controlador() { return Model.Recuperar; }
    get UsuarioActual() { return Model.Recuperar.UsuarioActual; }

    Estado: 'cargando' | 'iniciado' = 'iniciado';
    Error: string = '';
    Email: string = '';
    get Servidor(): string
    {
        return this.UsuarioActual.Email.substring( this.UsuarioActual.Email.search( '@' ) );
    }

    @Prop()
    Visible: boolean;
    @Watch( 'Visible' )
    onVisible()
    {
        this.Estado = 'iniciado';
        this.Error = '';
        this.Email = '';
    }

    public async Comprobar()
    {
        if ( this.Email.length < 1 )
        {
            document.getElementById( 'text-email' ).focus();
            this.Error = '¡Ingresá un email válido!';
            return;
        }

        this.Estado = 'cargando';
        let response = await this.Controlador.Enviar( this.Email.toLowerCase());
        if ( response != "enviado" )
        {
            this.Email = '';
            document.getElementById( 'text-email' ).focus();
            if ( response == "datos-incorrectos" )
            {
                this.Error = '¡El email no coincide!';
            }
            else if ( response == "error" )
            {
                this.Error = 'Ocurrió un error en el servicio';
            }
        }
        this.Estado = 'iniciado';
    }

}
